const REQUIRED_USER_KEYS = ['imageUrl', 'email', 'name'];

export const getAuthTokenCookieName = (state) => {
  return `unt_auth_token_${state.widgetId}`;
};

export const hasUserKeys = user =>
  REQUIRED_USER_KEYS.reduce((acc, key) => acc || !!user[key], false);
